import { render, staticRenderFns } from "./AutomaticUploadsHistoryTable.vue?vue&type=template&id=ce3ab128&"
import script from "./AutomaticUploadsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AutomaticUploadsHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticUploadsHistoryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
